module.exports = __webpack_public_path__ + "static/graphic-93d12504462611bc8ae465f4502139f2.webp";